import {svgIconWrapper} from '../svg-icon-wrapper';

import NutshellRegular from './nutshell-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <NutshellRegular {...props} />;
}

SvgComponent.iconName = 'nutshellRegular';

export const NutshellRegularIcon = svgIconWrapper(SvgComponent);
